export const SHOP_APPLICATION_FORM_ID = '9d5331e420b94725802134ce14201ca5';
export const SHOP_APPLICATION_FORM_ID = '9d5331e420b94725802134ce14201ca5';
